import React from 'react';

import Translation from '@swf/components/Translation/Translation';
import type { TranslationTag } from '@swf/core/types/i18n';
import { TabLinkMenu } from '@swf/sports/components';
import { getMyBetsAlias } from '@swf/sports/utils/getMyBetsAlias';

import { TXTWCL_Open_11, TXTWCL_Settled_1 } from './Tabs.messages.json';

// TODO de-dupe with widgets/sports-historical-bets-widget/components/Tabs/Tabs.tsx
interface Tab {
  status: 'open' | 'settled';
  translation: TranslationTag;
}

interface Props {
  isSelfExcluded: boolean;
  isEmbedded?: boolean;
}

const tabs: Tab[] = [
  {
    status: 'open',
    translation: TXTWCL_Open_11
  },
  {
    status: 'settled',
    translation: TXTWCL_Settled_1
  }
];

const Tabs: React.FC<Props> = ({ isSelfExcluded, isEmbedded }) => (
  <TabLinkMenu>
    {tabs.map(({ translation, status }) => (
      <TabLinkMenu.Link
        key={status}
        alias={getMyBetsAlias(isSelfExcluded, isEmbedded)}
        values={{ status }}
      >
        <Translation {...translation} />
      </TabLinkMenu.Link>
    ))}
  </TabLinkMenu>
);

export default Tabs;
